import i18next, { t } from 'i18next'
import React from 'react'
import { Pageheader } from '../components/pageheader'
import { useDocumentTitleEffect } from '../hooks/useDocumentTitleEffect'
import { translate } from './translate'

export const NotFoundPage = () => {
  useDocumentTitleEffect(t<string>('common:404:title'))
  return (
    <Pageheader
      title={t('common:404:title')}
      introduction={t('common:404:text')}
      primaryAction={{ external: false, label: t('common:404:return'), url: `/${i18next.language}` }}
      breadcrumbs={[
        { url: `/${i18next.language}`, title: translate('common:header:home', {}, 'Home') }
      ]}
    />
  )
}
